const accountPortalStateName = "accountPortal";
export {
  accountPortalStateName
};
//# sourceMappingURL=types.js.map
